import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import Vue from "vue";
import Vuex from "vuex";
// import createPersistedState from "vuex-persistedstate";



Vue.use(Vuex);

export default new Vuex.Store({
  namespaced: true,
  state: {},
  getters,
  mutations,
  actions
})
